var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "19px",
    viewBox: "0 0 31 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopHeader",
    transform: "translate(-913.000000, -15.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/",
    transform: "translate(913.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Arrowhead/down",
    transform: "translate(14.000000, 10.280767) rotate(30.000000) translate(-14.000000, -10.280767) ",
    points: "9 6 19 6 14 14.5615345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 29.5,
    height: 16.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/Player.a0d7596841e71a35f32090dc769915f0.svg";
export { ForwardRef as ReactComponent };